import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-8 md:py-12 bg-[#2d2d2d] text-white relative overflow-hidden" data-id="element-46">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-20" data-id="element-47">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#9d4b6b] to-transparent opacity-40" data-id="element-48" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-50">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6" data-id="element-51">
            ¿ESTÁS LISTA PARA TU NUEVO COMIENZO?
          </h2>

          <div className="text-lg md:text-xl text-gray-300 space-y-4 max-w-2xl mx-auto font-light" data-id="element-52">
            <p data-id="element-53">
              No tienes que aceptar una vida llena de silencios. No tienes que
              renunciar al amor. No tienes que seguir sintiéndote sola.
            </p>
            <p data-id="element-54">
              Puedes cambiar tu historia. Puedes revivir tu matrimonio. Puedes
              sanar tu corazón.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 my-12 max-w-xl mx-auto" data-id="element-55">
            <p className="text-xl md:text-2xl font-serif italic mb-2" data-id="element-56">
              El Divorcio Emocional
            </p>
            <p className="text-gray-400 mb-8" data-id="element-57">
              Está disponible ahora mismo. Solo necesitas un clic para empezar.
            </p>
            <CTAButton fullWidth className="text-xl py-5" scrollToPurchase data-id="element-58">
              Ver Oferta Especial
            </CTAButton>
          </div>

          <p className="text-gray-400 text-sm" data-id="element-59">
            Hazlo por ti. Hazlo por tu matrimonio. Hazlo por tu familia.
            <br data-id="element-60" />
            <span className="text-[#9d4b6b] font-medium mt-2 block text-lg" data-id="element-61">
              Tu renacer amoroso comienza hoy.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}